// extracted by mini-css-extract-plugin
export default {"popupInner":"MultiFactorAuthenticationPopup__popupInner--rQd","layout":"MultiFactorAuthenticationPopup__layout--1sb","container":"MultiFactorAuthenticationPopup__container--2nG"};